import React from 'react';
import Fancybox from '../../../../utils/fancybox';
import {PLACEHOLDER_IMAGE_URL} from '../../../../mock/constants';
import {IChatGroupItem} from '../../../../types/chat';

type ChatHeaderProps = {
  selectedUser: IChatGroupItem;
};

const ChatHeader = ({selectedUser}: ChatHeaderProps) => (
    <div className="card-header" id="kt_chat_messenger_header">
      <div className="card-title">
        <div className="symbol-group symbol-hover">
          <Fancybox>
            <div className="symbol symbol-40px symbol-circle pe-3">
              {selectedUser?.image ? (
                  <img
                      className={"object-fit-cover"}
                      data-fancybox="gallery"
                      data-src={selectedUser?.image || PLACEHOLDER_IMAGE_URL}
                      data-caption={selectedUser?.name}
                      src={selectedUser?.image || PLACEHOLDER_IMAGE_URL}
                      alt={selectedUser?.name}
                  />
              ) : (
                  <span className={"symbol-label fs-2x fw-semibold text-success bg-light-success"}>
                {selectedUser?.name[0].toUpperCase()}
              </span>
              )}
            </div>
          </Fancybox>
        </div>
        <div className="d-flex justify-content-center flex-column me-3">
        <span className="fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-1 lh-1">
          {selectedUser?.name}
        </span>
        </div>
      </div>
    </div>
);

export default ChatHeader;